import React from 'react';
import { useCurrentUser, useTranslate } from '@hooks';
import { getNameWithId } from '@dotone/react-ui-core/utils';
import { TablePaginated } from '@dotone/react-ui-core';
import FilterForm from './CampaignFilterForm';
import FilterList from './CampaignFilterList';
import {
  formatCampaignApprovalStatus,
  formatDefaultPayouts,
  formatCustomPayouts,
} from './formatters';
import { formatOffer, formatAvatar } from '../formatters';

const getColumns = ({ t, currentUser, full }) => [
  {
    dataField: 'offer',
    text: t('::common:model.offer'),
    hidden: currentUser.singleOffer,
    formatter: (cell) => cell && formatOffer(cell.brandImageMediumUrl),
  },
  {
    dataField: 'affiliate',
    text: t('::common:model.affiliate'),
    hidden: !full,
    formatter: (cell) => (cell.canAccess ? getNameWithId(cell) : cell.id),
  },
  {
    dataField: 'affiliate.avatarCdnUrl',
    text: t('avatar'),
    headerAlign: 'center',
    classes: 'text-center',
    hidden: !full,
    formatter: (cell, row) => formatAvatar(row.affiliate),
  },
  {
    dataField: 'defaultPayouts',
    text: t('table.defaultPayouts'),
    formatter: (cell) => formatDefaultPayouts(cell, { t }),
  },
  {
    dataField: 'customPayouts',
    text: t('table.customPayouts'),
    formatter: (cell) => formatCustomPayouts(cell, { t }),
  },
  {
    dataField: 'approvalStatus',
    text: t('::common:model.status'),
    style: { maxWidth: 140 },
    formatter: (cell, row) => formatCampaignApprovalStatus(cell, row, { t, currentUser }),
  },
];

const CampaignTable = ({ full = false, ...otherProps }) => {
  const { t } = useTranslate('campaign', 'model');
  const { currentUser } = useCurrentUser();

  const columns = getColumns({ t, currentUser, full });

  return (
    <TablePaginated
      remote
      condensed
      responsive
      hover
      classes="stylish-table table-sm text-sm"
      keyField="id"
      columns={columns}
      filterRenderer={(filterProps) => <FilterForm full={full} {...filterProps} />}
      filterListRenderer={(filters) => <FilterList full={full} filters={filters} />}
      {...otherProps}
    />
  );
};

export default CampaignTable;
